/*
 * Copyright (c) 2023. Collabro Limited
 */

import { PaletteMode } from "@mui/material";
import { ThemeOptions } from "@mui/material/styles";
import ModecLight from "./ModecLight";
import ModecDark from "./ModecDark";

const modecTheme = (mode: PaletteMode): ThemeOptions => {
  return mode === "light" ? ModecLight : ModecDark;
};

export default modecTheme;
